import React, { useEffect, useState } from 'react';
import '../styles/SideBarRight.css';
import '../styles/SideBarToggle.css';

import CollapseIconHover from '../../images/IconRightArrowBlue@3x.png';
import CollapseIcon from '../../images/IconRightArrowGrey@3x.png';
import PlaceholderImage from '../../images/PlaceholderImage.png';
import IconClear from '../../images/IconClear@3x.png';
import IconClearBlue from '../../images/IconClearBlue@3x.png';
import { getBasePlanDisplayLabel } from './basePlanSelection';

export default function BuiltSideBarRight({
  isExpanded = true,
  onRequestClose = () => {},
  selectedHome,
  showEditButton = false,
  onEditHome = () => {},
  onOpenPhoto = () => {},
  onOpenPlansPdf = () => {},
  clearSelection = () => {},
}) {
  const [isCollapseButtonHovering, setIsCollapseButtonHovering] = useState(false);
  const [isSidebarVisible, setIsSidebarVisible] = useState(isExpanded);
  const [shouldRenderContent, setShouldRenderContent] = useState(isExpanded);
  const [isClearButtonHovered, setIsClearButtonHovered] = useState(false);

  useEffect(() => {
    let timeoutId;
    if (isExpanded) {
      setShouldRenderContent(true);
      setIsSidebarVisible(true);
      setIsCollapseButtonHovering(false);
    } else {
      setIsSidebarVisible(false);
      timeoutId = window.setTimeout(() => setShouldRenderContent(false), 300);
    }

    return () => window.clearTimeout(timeoutId);
  }, [isExpanded]);

  const selectedHomeTitle = selectedHome?.clientName || selectedHome?.address || 'Fraemohs home';
  const basePlanLabel = getBasePlanDisplayLabel(selectedHome);

  const renderSelectedHome = () => (
    <div className="sidebarRight-plan">
      {selectedHome.photo ? (
        <button
          type="button"
          className="built-sidebar-photo-button"
          onClick={onOpenPhoto}
          aria-label={`Open larger photo for ${selectedHomeTitle}`}
        >
          <img
            src={selectedHome.photo}
            alt={selectedHome.address || selectedHomeTitle}
            className="sidebarRight-plan-image"
          />
        </button>
      ) : (
        <img
          src={PlaceholderImage}
          alt={selectedHome.address || selectedHomeTitle}
          className="sidebarRight-plan-image"
        />
      )}

      <div className="sidebarRight-plan-info-title" style={{ marginTop: 20, display: 'flex', alignItems: 'center' }}>
        <div style={{ fontWeight: 600, fontSize: 16, flex: 1, marginRight: 16, wordBreak: 'break-word' }}>
          {selectedHome.clientName || 'Fraemohs Home'}
        </div>
        <button
          onClick={() => {
            clearSelection();
            setIsClearButtonHovered(false);
          }}
          title="Clear selection"
          style={{ background: 'none', border: 'none', marginLeft: 'auto', padding: 0, cursor: 'pointer', display: 'flex', alignItems: 'center' }}
        >
          <img
            src={isClearButtonHovered ? IconClearBlue : IconClear}
            alt="Clear home info"
            onMouseEnter={() => setIsClearButtonHovered(true)}
            onMouseLeave={() => setIsClearButtonHovered(false)}
            style={{
              height: 18,
              width: 18,
              cursor: 'pointer',
              borderRadius: '50%',
              transition: 'box-shadow 0.2s ease',
              boxShadow: isClearButtonHovered ? 'var(--ph-box-shadow-hover)' : 'none',
            }}
          />
        </button>
      </div>

      <div className="sidebarRight-collapsible-content expanded">
        <div className="sidebarRight-landinfo-section" style={{ marginTop: 15 }}>
          <div className="sidebarRight-landinfo-row">
            <span className="label">Address:</span>
            <span className="value">{selectedHome.address || ''}</span>
          </div>
          <div className="sidebarRight-landinfo-row">
            <span className="label">Build Style:</span>
            <span className="value">{selectedHome.buildStyle || ''}</span>
          </div>
          <div className="sidebarRight-landinfo-row">
            <span className="label">Type:</span>
            <span className="value">{selectedHome.type || ''}</span>
          </div>
          {basePlanLabel && (
            <div className="sidebarRight-landinfo-row">
              <span className="label">Base Plan:</span>
              <span className="value">{basePlanLabel}</span>
            </div>
          )}
          <div className="sidebarRight-landinfo-row">
            <span className="label">Consented:</span>
            <span className="value">{selectedHome.consentedDate ? new Intl.DateTimeFormat('en-NZ', { timeZone: 'UTC' }).format(new Date(selectedHome.consentedDate)) : ''}</span>
          </div>
          <div className="sidebarRight-landinfo-row">
            <span className="label">Year Built:</span>
            <span className="value">{selectedHome.completedYear || ''}</span>
          </div>
          <div className="sidebarRight-landinfo-row">
            <span className="label">Sales Consultant:</span>
            <span className="value">{selectedHome.salesConsultantName || ''}</span>
          </div>
        </div>
      </div>

      {selectedHome.plansPdf && (
        <div className="sidebarRight-document-actions">
          <button type="button" className="sidebarRight-landinfo-row sidebarRight-document-row" onClick={onOpenPlansPdf}>
            <span>View Plans PDF ›</span>
          </button>
        </div>
      )}

      {showEditButton && (
        <div className="sidebarRight-admin-actions">
          <button type="button" className="sidebarRight-landinfo-row sidebarRight-admin-edit-row" onClick={onEditHome}>
            <span>Edit Home (admin) ›</span>
          </button>
          {selectedHome.needsReview === 1 && (
            <div className="sidebarRight-needs-review-note">This entry needs review</div>
          )}
        </div>
      )}
    </div>
  );

  return (
    <div
      className="sidebarRight"
      style={{
        width: '100%',
        flex: 1,
        opacity: isSidebarVisible ? 1 : 0,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        borderLeft: isExpanded ? '0.75px solid #596A99' : 'none',
        transition: 'flex-basis 0.3s ease, opacity 0.3s ease',
        position: 'relative',
      }}
    >
      {isExpanded && (
        <button
          className="sidebar-toggle-button sidebar-right-toggle-button-expanded"
          onClick={onRequestClose}
          onMouseEnter={() => setIsCollapseButtonHovering(true)}
          onMouseLeave={() => setIsCollapseButtonHovering(false)}
        >
          <img src={isCollapseButtonHovering ? CollapseIconHover : CollapseIcon} alt="Hide Sidebar" />
        </button>
      )}

      {shouldRenderContent && selectedHome && (
        <div className="sidebarRight-inner">
          <div className="sidebarRight-scrollable">
            <div className="sidebarRight-scrollarea">
              {renderSelectedHome()}
              <div className="sidebarRight-version">v1.0</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
